import { graphql } from "@/types/gql";

export const QUERY_URBAN_FEATURE = graphql(`
  query UrbanFeaturesByBounding($boundingbox: [[Float!]!], $cityId: String!, $types: [UrbanFeatureType!]) {
    urbanFeaturesByBounding(cityId: $cityId, boundingbox: $boundingbox, types: $types) {
      name
      address {
        city
        country
        postalCode
        province
        streetName
        streetNumber
      }
      geometry
      type
      cityId
      id
      editLine
      width
    }
  }
`);

export const QUERY_ADD_URBAN_FEATURE = graphql(`
  mutation addUrbanFeatureToCity($createUrbanFeaturesInput: CreateUrbanFeaturesInput!) {
    addUrbanFeatureToCity(createUrbanFeaturesInput: $createUrbanFeaturesInput) {
      name
      address {
        city
        country
        postalCode
        province
        streetName
        streetNumber
      }
      geometry
      type
      cityId
      id
      editLine
      width
    }
  }
`);

export const QUERY_UPDATE_URBAN_FEATURE = graphql(`
  mutation updateUrbanFeature($updateUrbanFeatureInput: UpdateUrbanFeatureInput!) {
    updateUrbanFeature(updateUrbanFeatureInput: $updateUrbanFeatureInput) {
      name
      address {
        city
        country
        postalCode
        province
        streetName
        streetNumber
      }
      geometry
      type
      cityId
      id
      editLine
      width
    }
  }
`);

export const QUERY_REMOVE_URBAN_FEATURE = graphql(`
  mutation removeUrbanFeature($urbanFeatureId: String!) {
    removeUrbanFeature(urbanFeatureId: $urbanFeatureId) {
      id
    }
  }
`);
